import React from 'react';
import { Link } from 'react-router-dom';

const GRID_BG = {
  backgroundImage:
    'linear-gradient(rgba(201,168,76,0.12) 1px, transparent 1px), linear-gradient(90deg, rgba(201,168,76,0.12) 1px, transparent 1px)',
  backgroundSize: '60px 60px',
};

const OurServices = () => {
  return (
    <div className="pt-20">

      {/* Page header */}
      <section className="relative bg-navy-800 py-20 overflow-hidden">
        <div className="absolute inset-0" style={GRID_BG} />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-gold-500 text-sm font-bold uppercase tracking-widest mb-4">What We Do</p>
          <h1 className="text-4xl md:text-5xl font-black text-white font-heading mb-6">Our Services</h1>
          <p className="text-slate-300 text-lg max-w-2xl mx-auto leading-relaxed">
            Two focused service lines, each purpose-built to serve the unique demands of the federal government.
          </p>
        </div>
      </section>

      {/* Service cards */}
      <section className="bg-slate-50 py-24">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-10">

            <div className="bg-white rounded-2xl p-10 shadow-sm border border-gray-100 hover:border-gold-200 hover:shadow-lg transition-all group">
              <div className="w-16 h-16 bg-gold-500/10 border border-gold-200 rounded-2xl flex items-center justify-center mb-6 group-hover:bg-gold-500/20 transition-colors">
                <span className="text-3xl">🏢</span>
              </div>
              <h2 className="text-2xl font-black text-navy-800 font-heading mb-3">
                Facilities Management &amp; Space Planning
              </h2>
              <p className="text-slate-500 leading-relaxed mb-8">
                Comprehensive workplace solutions including space management, move coordination, signage, help desk
                support, and IWMS/CAFM/CMMS implementation for federal facilities.
              </p>
              <Link
                to="/services/facilities"
                className="inline-flex items-center gap-2 bg-navy-800 hover:bg-navy-700 text-white px-6 py-3 rounded-xl font-bold text-sm transition-colors"
              >
                Explore Facilities Services
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </Link>
            </div>

            <div className="bg-white rounded-2xl p-10 shadow-sm border border-gray-100 hover:border-gold-200 hover:shadow-lg transition-all group">
              <div className="w-16 h-16 bg-gold-500/10 border border-gold-200 rounded-2xl flex items-center justify-center mb-6 group-hover:bg-gold-500/20 transition-colors">
                <span className="text-3xl">💻</span>
              </div>
              <h2 className="text-2xl font-black text-navy-800 font-heading mb-3">
                Information Technology Services
              </h2>
              <p className="text-slate-500 leading-relaxed mb-8">
                Full-spectrum IT support covering project management, governance &amp; compliance (FISMA, NIST),
                DevOps, and cybersecurity — built for the federal technology environment.
              </p>
              <Link
                to="/services/it"
                className="inline-flex items-center gap-2 bg-navy-800 hover:bg-navy-700 text-white px-6 py-3 rounded-xl font-bold text-sm transition-colors"
              >
                Explore IT Services
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </Link>
            </div>

          </div>
        </div>
      </section>

    </div>
  );
};

export default OurServices;
